import { useMemo } from 'react';

import { Modal, Text } from '@thefarmersfront/kitchen';

import { ResultStatusSummary, Table } from '~/components/common';

import { getDeliveryAgencyOrderExcelUploadFailColumnDefs } from '~/utils/delivery-agency/table';

import type { TypeDeliveryAgencyOrdersUploadResult } from '~/types/delivery-agency.types';

import styles from './DeliveryAgencyOrderExcelUploadFailModal.module.scss';

const FAIL_TABLE_HEIGHT = 396;

const DeliveryAgencyOrderExcelUploadFailModal = ({
  data,
  open,
  onClose,
}: {
  data: TypeDeliveryAgencyOrdersUploadResult;
  open: boolean;
  onClose: () => void;
}) => {
  const { columnDefs } = useMemo(() => getDeliveryAgencyOrderExcelUploadFailColumnDefs(), []);

  return (
    <Modal title="주문 엑셀 등록 실패" size="large" open={open} onConfirm={onClose}>
      <div className={styles['contents-container']}>
        <ResultStatusSummary totalCount={data.totalCount} successCount={data.successCount} failCount={data.failCount} />
        <div className={styles['table-container']}>
          <Text size="large" weight="semi-bold">
            업로드 실패 내역
          </Text>
          <Table data={data.failDetails} columns={columnDefs} height={FAIL_TABLE_HEIGHT} />
        </div>
      </div>
    </Modal>
  );
};

export default DeliveryAgencyOrderExcelUploadFailModal;
